// frontend/src/store/slices/authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

// Async action to log in
export const login = createAsyncThunk(
    'auth/login',
    async (credentials, { rejectWithValue }) => {
        try {
            console.log('[authSlice] Attempting login for:', credentials.email);
            const { data } = await api.post('/auth/login', credentials);
            console.log('[authSlice] Login response received');

            if (data.requiresPasswordChange && data.passwordSetupToken) {
                sessionStorage.setItem('passwordSetupToken', data.passwordSetupToken);
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                return { requiresPasswordChange: true };
            }

            if (data.token && data.user) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('user', JSON.stringify(data.user));
                localStorage.removeItem('sessionExpired');
                return { user: data.user };
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (err) {
            console.error('[authSlice] Login error:', err);
            console.error('[authSlice] Error response:', err.response?.data);

            // Extract error message from response
            let errorMessage = 'Login failed. Please check your credentials.';
            if (err.response?.data?.error) {
                errorMessage = err.response.data.error;
            } else if (err.response?.data?.message) {
                errorMessage = err.response.data.message;
            } else if (err.message) {
                errorMessage = err.message;
            }

            return rejectWithValue(errorMessage);
        }
    }
);

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        user: JSON.parse(localStorage.getItem('user')) || null,
        token: localStorage.getItem('token') || null,
        loading: false,
        error: null,
    },
    reducers: {
        logout: (state) => {
            state.user = null;
            state.token = null;
            state.error = null;
            localStorage.removeItem('token');
            localStorage.removeItem('user');
        },
        setUser: (state, action) => {
            state.user = action.payload;
            localStorage.setItem('user', JSON.stringify(action.payload));
        },
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(login.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload.user || null;
                state.token = action.payload.user ? localStorage.getItem('token') : null;
                state.error = null;
                localStorage.removeItem('sessionExpired');
            })
            .addCase(login.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Login failed. Please try again.';
                console.log('[authSlice] Error set in state:', state.error);
            });
    },
});

export const { logout, setUser, clearError } = authSlice.actions;
export default authSlice.reducer;